/*
 * @Author: Mufaddal Jamali
 * @Date: 2020-02-24 15:49:21
 * @Last Modified by: Mufaddal Jamali
 * @Last Modified time: 2021-01-28 13:52:04
 */

import React, { Component } from "react";
import { DataService } from "../services/data.service";

import $ from "jquery";

import { Empty } from "antd";
import Loader from "../components/loader/loader";
import * as handler from "../components/utils/handler";

import dummyData from "../data/deviceDetails.json";

import { Select } from "antd";

const { Option } = Select;

class DeviceDetails extends Component {
  model = undefined;
  color = null;
  selectedProductType = null;
  selectedProductFamily = null;
  imei = null;
  service = new DataService();
  state = {
    phoneModels: [],
    phoneColors: [],
    productTypes: [],
    productFamily: [],

    selectedModel: undefined,

    dataLoaded: false,
    lang: {},
  };
  imeiRef = React.createRef();
  isValidIemiSerielNumber = false;
  defaultLanguage = window["app-config"].defaultLang;
  URL = window["app-config"].URL;

  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
    this.props.hideBtnNext();
    this.props.setHeading(null);
    this.getDeviceDetails();
    // this.getUpdatedDeviceDetails();
    $(".validate-text").on("keypress", function (event) {
      var regex = new RegExp("^[a-zA-Z0-9]+$");
      var key = String.fromCharCode(
        !event.charCode ? event.which : event.charCode
      );
      if (!regex.test(key)) {
        event.preventDefault();
        return false;
      }
    });
  }

  getDeviceDetails = async () => {
    try {
      let response = await this.service.getDeviceDetails();

      if (response.data.error !== undefined && response.data.error === true) {
        this.setState({
          productTypes: undefined,
          dataLoaded: true,
        });
      } else {
        let productTypes = response.data.productsInfo.productTypes;
        this.setState({
          productTypes: productTypes === "" ? [] : productTypes,
          dataLoaded: true,
        });
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        this.setState({
          productTypes: undefined,
          phoneColors: [],
          productFamily: [],
          phoneModels: [],
          dataLoaded: true,
        });
      } else {
        this.setState({
          productTypes: [],
          productFamily: [],
          phoneModels: [],
          phoneColors: [],
          dataLoaded: true,
        });
      }
    }
  };

  getUpdatedDeviceDetails = () => {
    this.setState({ productTypes: dummyData.productTypes });
  };

  onModelSearch = (val) => {
    console.log("search:", val);
  };

  _onProductTypeChange = (e) => {
    this.selectedProductType = e.target.value;
    this.sendDataToParent();

    $("#family-selector").val("-1");
    $("#color-selector").val("-1");
    this.props.hideBtnNext();

    let family = this.state.productTypes.filter(
      (f) => f.ProductName === e.target.value
    );

    this.setState({
      productFamily: family[0].ProductFamily,
      phoneModels: [],
      selectedModel: undefined,
    });
  };

  _onProductFamilyChange = (e) => {
    this.selectedProductFamily = e.target.value;
    this.sendDataToParent();

    $("#model-selector").val("-1");
    $("#color-selector").val("-1");
    this.props.hideBtnNext();

    let models = this.state.productFamily.filter(
      (f) => f.FamilyName === e.target.value
    );

    this.setState({
      phoneModels: models[0].phoneModels,
      selectedModel: undefined,
    });
  };

  _onModelChange = (value) => {
    // this.model = value;
    this.setState({ selectedModel: value });

    this.sendDataToParent();

    $("#color-selector").val("-1");
    this.props.hideBtnNext();

    var colors = this.state.phoneModels.filter((c) => c.ModelName === value);

    this.setState({ phoneColors: colors[0].PhoneColor });
  };

  _onModelSearch = (val) => {
    console.log("search:", val);
  };

  _onColorChange = (e) => {
    this.color = e.target.value;

    this.sendDataToParent();
  };

  sendDataToParent = () => {
    this.props.deviceDetails({
      model: this.state.selectedModel,
      color: this.color,
      productType: this.selectedProductType,
      productFamily: this.selectedProductFamily,
    });
  };

  render() {
    if (this.state.productTypes === undefined) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <div className="sl__modal--row">
              <Empty description={this.state.lang.ServerNotResponding} />
            </div>
          </div>
        </div>
      );
    } else if (this.state.dataLoaded === false) {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellDeviceDetailsHeading}</h2>
            <Loader />
          </div>
        </div>
      );
    } else {
      return (
        <div className="sl__modal-inner">
          <div className="sl__modal--content">
            <h2>{this.state.lang.TellDeviceDetailsHeading}</h2>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.ProductTypeLabel}
                  <span className="estaric">*</span>
                </label>

                <select
                  id="product-type-selector"
                  onChange={this._onProductTypeChange}
                  className="sl__modal_form--select"
                  defaultValue={-1}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ProductTypePlaceholder}
                  </option>

                  {this.state.productTypes !== null &&
                  this.state.productTypes.length > 0
                    ? this.state.productTypes.map((data, i) => {
                        return (
                          <option value={data.ProductName} key={i}>
                            {data.ProductName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>

              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.ProductFamilyLabel}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="family-selector"
                  onChange={this._onProductFamilyChange}
                  className="sl__modal_form--select"
                  defaultValue={-1}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ProductFamilyPlaceholder}
                  </option>

                  {this.state.productFamily.length > 0
                    ? this.state.productFamily.map((data, i) => {
                        return (
                          <option value={data.FamilyName} key={i}>
                            {data.FamilyName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>

            <div className="sl__modal_form-row">
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhichDeviceDoYouHave}
                  <span className="estaric">*</span>
                </label>

                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder={this.state.lang.ChooseYourModel}
                  optionFilterProp="children"
                  onChange={this._onModelChange}
                  onSearch={this._onModelSearch}
                  className="antSelect"
                  id="model-selector"
                  value={this.state.selectedModel}
                >
                  {this.state.phoneModels !== null
                    ? this.state.phoneModels.map((data, i) => {
                        return (
                          <Option value={data.ModelName} key={i}>
                            {data.ModelName}
                          </Option>
                        );
                      })
                    : null}
                </Select>
              </div>
              <div className="sl__modal_form-col">
                <label className="sl__modal_form--label">
                  {this.state.lang.WhatIsTheColourOfYourDevice}
                  <span className="estaric">*</span>
                </label>
                <select
                  id="color-selector"
                  onChange={this._onColorChange}
                  className="sl__modal_form--select"
                  defaultValue={-1}
                >
                  <option disabled value={-1}>
                    {this.state.lang.ChooseYourColor}
                  </option>

                  {this.state.phoneColors.length > 0 &&
                  this.state.selectedModel !== undefined
                    ? this.state.phoneColors.map((data, i) => {
                        return (
                          <option value={data.ColorName} key={i}>
                            {data.ColorName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default DeviceDetails;
